import httpClient, { ExtendedAxiosRequestConfig } from '../../api/httpClient';
import parishService from './parishService';
import { TaxCode } from '../constants/enums';
async function initialdata() {
  return await httpClient.get('api/users/initialdata');
}

async function getBranches() {
  // Configuración de caché - tiempo más largo para el servicio compartido
  const config: ExtendedAxiosRequestConfig = {
    cache: {
      enabled: true,
      duration: 2 * 1000, // 30 segundos de staleTime (igual que en branchesService)
      cacheTime: 2 * 1000, // 1 minuto en caché total
      key: 'all-branches-data', // Misma clave que en branchCacheService
      refetchOnWindowFocus: false,
    },
  };

  const response = await httpClient.get(`api/branches/get-branches`, config);
  return response;
}

async function getEmissionPoint() {
  return await httpClient.get(`api/users/get-emission-point`);
}

async function setEmissionPoint(emisionPoint) {
  return await httpClient.post(`api/users/set-emission-point`, emisionPoint);
}

async function logout() {
  return await httpClient.post(`api/users/logout`, null);
}

async function getAllProducts() {
  let filterSort = {
    filters: [],
    sort: {
      sortField: 'id',
      sortOrder: 1,
      sortPartner: null,
    },
  };
  return await httpClient.post(`api/products/all?page=${0}&size=${1}`, filterSort);
}

async function getParish(parish: string = '') {
  // Usar el nuevo servicio de parroquias con caché de 24 horas
  return await parishService.getParishList(parish);
}

async function getPersons(identification: string) {
  return await httpClient.get(`api/person/get-by-identification?identification=${identification}`);
}

function getTaxesByType(taxType: string = TaxCode.IVA) {
  const url = `api/taxes/by-type/${taxType}`;

  // Configuración de caché para impuestos
  const config: ExtendedAxiosRequestConfig = {
    cache: {
      enabled: true,
      duration: 5 * 60 * 1000, // 5 minutos de staleTime
      cacheTime: 10 * 60 * 1000, // 10 minutos en caché total
      key: `taxes-by-type-${taxType}`, // Clave única por tipo
      refetchOnWindowFocus: false,
    },
  };

  return httpClient.get(url, config);
}

function getActiveSupportCodes() {
  const config: ExtendedAxiosRequestConfig = {
    cache: {
      enabled: true,
      duration: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      key: 'active-support-codes',
      refetchOnWindowFocus: false,
    },
  };

  return httpClient.get('api/support-codes/active', config);
}

export default {
  initialdata,
  getBranches,
  getEmissionPoint,
  setEmissionPoint,
  logout,
  getAllProducts,
  getParish,
  getPersons,
  getTaxesByType,
  getActiveSupportCodes,
};
